import { render, staticRenderFns } from "./lingid.vue?vue&type=template&id=2f99874a&"
import script from "./lingid.vue?vue&type=script&lang=js&"
export * from "./lingid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports